import React from "react";
import Popover from "~/common/Popover";

const HelpIcon = () => (
  <Popover
    title="SMS Text Messages"
    triggerElement={(ref: React.RefObject<HTMLAnchorElement>) => (
      <a className="more-info" href="##" ref={ref}>
        <i className="icon-question" />
      </a>
    )}
    options={{
      placement: "bottom",
    }}
  >
    <p>Phone number must be able to receive text messages</p>
    <p className="small">
      Message and data rates may apply. You may opt-out at any time by sending
      STOP to +17172887303. (Note: if you texted STOP but would like to restart,
      text START, and make sure your number below is correct.)
    </p>
  </Popover>
);

export default HelpIcon;
